import { FC } from 'react'

const NotFoundView : FC = () => {
    return(
        <></>
    )
}

export default NotFoundView